<template>
  <main>
    <iframe
      src="https://subscribepage.io/inicia"
      style="width: 100%; height: 100vh; border: none;"
      frameborder="0"
      allowfullscreen
      loading="lazy"
    >
    </iframe>
  </main>
</template>

<script>
export default {
  name: 'LandingUpgradePlan'
}
</script>
